import type {DiscountBadge} from '@/modules/common/context/SeaCampaign/models';

import {useBreakpointDown} from '@travel-frontend/core';
import {
  Tooltip,
  Discount,
  Dialog,
  DialogHead,
  DialogBody,
} from '@travel-frontend/ui-components';
import {useState} from 'react';

import {TooltipMarkdown} from '@/components/TooltipMarkdown';
import {Container} from '@/modules/hotels/components/SeaSpotlight/components/Badge/components/Container';
import {Content} from '@/modules/hotels/components/SeaSpotlight/components/Badge/components/Content';
import {Target} from '@/modules/hotels/components/SeaSpotlight/components/Badge/components/Target';
import {SpotlightPromoBadge} from '@/modules/hotels/components/SeaSpotlight/components/SpotlightPromoBadge';
import {TrustBadge} from '@/modules/hotels/components/SeaSpotlight/components/TrustBadge';

type Props = {
  data: DiscountBadge;
};

export const Badge: React.FunctionComponent<Props> = ({data}) => {
  let badge = null;
  const mdDown = useBreakpointDown('md');
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDialogOpen = () => setDialogOpen(true);
  const handleDialogClose = () => setDialogOpen(false);

  if (data.type === 'waterdrop') {
    badge = (
      <Discount
        value={data.value}
        badgeColor={data.badgeColor}
        textColor={data.textColor}
        rotateRight
      />
    );
  }

  if (data.type === 'trustElement') {
    badge = (
      <TrustBadge
        imageMedium={data.imageMedium}
        imageSmall={data.imageSmall}
        imageLarge={data.imageLarge}
      />
    );
  }

  if (data.type === 'promotion') {
    badge = (
      <SpotlightPromoBadge
        badgeColor={data.badgeColor || '#e8494f'}
        textColor={data.textColor || '#ffffff'}
        caption={data.caption || ''}
        linkUrl={data.linkUrl}
      />
    );
  }

  if (badge === null) {
    return null;
  }

  const target = (
    <Target
      onClick={mdDown ? handleDialogOpen : undefined}
      justifyContent="center"
      flexWrap="nowrap"
    >
      {badge}
    </Target>
  );

  if (!data.tooltipText) {
    return <Container>{badge}</Container>;
  }

  return (
    <Container>
      {mdDown ? (
        <>
          <Dialog open={dialogOpen} onClose={handleDialogClose}>
            <DialogHead onClose={handleDialogClose} />
            <DialogBody>
              <Content content={data?.tooltipText || ''} />
            </DialogBody>
          </Dialog>
          {target}
        </>
      ) : (
        <Tooltip
          // @ts-expect-error TS2322
          tabIndex={0}
          role="tooltip"
          aria-label="Angebots Information"
          interactive
          width={320}
          placement="left"
          content={<TooltipMarkdown value={data?.tooltipText || ''} />}
        >
          {target}
        </Tooltip>
      )}
    </Container>
  );
};
